import { render } from "./Bill.vue?vue&type=template&id=2d6b0125&scoped=true"
import script from "./Bill.vue?vue&type=script&lang=js"
export * from "./Bill.vue?vue&type=script&lang=js"

import "./Bill.vue?vue&type=style&index=0&id=2d6b0125&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6b0125"]])

export default __exports__